import { Component, OnInit, ViewChild, Input, ElementRef } from '@angular/core';
import { EmailDetail } from '../model/email-detail.model';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { CommunicationService } from '../communication.service';

import { CrawfordSnackbarService, ITabComponent, CrawfordDialogComponent, DialogButton, CrawfordDownloadService } from 'crawford-shell';

import { global } from '../../app.settings';
import { DocumentDownload } from '../model/document-download.model';
import { DocumentDownloadComponent } from '../document-download/document-download.component';


@Component({
  selector: 'app-email',
  templateUrl: './email.component.html',
  styleUrls: ['./email.component.scss']
})
export class EmailComponent implements OnInit {

  public bodyText: string;
  public eventId: number;
  public emailDetailsForm: FormGroup;
  protected _emailDetail: EmailDetail;

  @ViewChild('documentDownload') private documentDownload: DocumentDownloadComponent;

  @Input() public crawfordRef: string;
  @Input() set emailDetail(value: EmailDetail) {
    this._emailDetail = value;
    if (this.emailDetail) {
      this.setFormValues();
      this.emailDetailsForm.disable();
    } else {
      if (this.emailDetailsForm) {
      this.emailDetailsForm.disable();
      }
    }
  }


  get emailDetail(): EmailDetail {
    return this._emailDetail;
  }

  constructor(
    private activatedRoute: ActivatedRoute,
    private communicationService: CommunicationService,
    private formBuilder: FormBuilder,
    private snackbarService: CrawfordSnackbarService,
    private downloadService: CrawfordDownloadService
  ) {
    this.createEmailDetailsForm();
  }

  ngOnInit() {
  }

  setFormValues(): any {
    this.emailDetailsForm.reset({
      sentBy: this.emailDetail.sentBy,
      recipientTo: this.emailDetail.recipientTo,
      recipientCC: this.emailDetail.recipientCC,
      subject: this.emailDetail.subject,
    });

    this.bodyText = this.emailDetail.bodyText;

    const document: DocumentDownload = {
      id: this._emailDetail.eventId,
      name: this._emailDetail.attachmentName,
      icon: this._emailDetail.iconClass
    };

    this.documentDownload.details = document;
  }

  createEmailDetailsForm(): any {
    this.emailDetailsForm = this.formBuilder.group({
      sentBy: new FormControl(),
      recipientTo: new FormControl(),
      recipientCC: new FormControl(),
      subject: new FormControl(),
      attachment: new FormControl()
    });
  }

  public openDocument(email: EmailDetail) {
    this.communicationService.getOpenDocument(this.crawfordRef, email.eventId).subscribe(
      response => {
        if (response) {
          this.downloadService.downloadFileFromResponse(response, email.attachmentName);
        } else {
          this.snackbarService.displayErrorMessage('Unable to download document ' + email.attachmentName);
        }
      });
  }

}



// WEBPACK FOOTER //
// D:/a/1/s/UI/src/app/communication/email/email.component.ts